// extracted by mini-css-extract-plugin
var _1 = "768px";
var _2 = "\"../../../shared.module.css\"";
var _3 = "Textarea_textareaIn__dtbYO";
export { _1 as "md", _2 as "shared", _3 as "textareaIn" }
